"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "carovilli": {
    "1171c2ee": [{
      "hkey": "635d2e69",
      "slug": "carovilli",
      "name": "Carovilli",
      "primary": true,
      "skipSearch": false
    }],
    "briccioso": [{
      "hkey": "635d2e69",
      "slug": "carovilli",
      "name": "Carovilli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8beb1613": [{
      "hkey": "635d2e69",
      "slug": "carovilli",
      "name": "Carovilli",
      "primary": true,
      "skipSearch": false
    }],
    "cegna-ciffuni": [{
      "hkey": "635d2e69",
      "slug": "carovilli",
      "name": "Carovilli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eac6ef4d": [{
      "hkey": "635d2e69",
      "slug": "carovilli",
      "name": "Carovilli",
      "primary": true,
      "skipSearch": false
    }],
    "cerrosavino": [{
      "hkey": "635d2e69",
      "slug": "carovilli",
      "name": "Carovilli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;